import _ from "lodash";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  FaBoxes,
  FaBullhorn,
  FaChartLine,
  FaCog,
  FaCogs,
  FaCoins,
  FaEnvelope,
  FaHome,
  FaImages,
  FaList,
  FaProjectDiagram,
  FaRegBell,
  FaTags,
  FaTruck,
  FaUsers,
} from "react-icons/fa";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  UncontrolledDropdown,
} from "reactstrap";
import { bindActionCreators } from "redux";
import * as actions from "../../../actions";
import {
  appearancesDropMenu,
  categoryDropDownMenu,
  deliveryConfigurationsDropMenu,
  ordersDropMenu,
  pointsSystemDropMenu,
  productConfigurationsDropMenu,
  productsDropDownMenu,
  promotionsDropMenu,
  reportsDropMenu,
  voucherDropMenu,
} from "./misc";

const Navigation = (props) => {
  const { default_path, user } = props.authentication;

  const isActive = (route) => {
    const { pathname } = window.location;
    return pathname === route || (route !== "/" && pathname.startsWith(route))
      ? "active"
      : "";
  };

  const orderPath =
    default_path === "/admins/" ? "/admins/cart_orders/" : "/partners/orders/";

  const usersLink =
    default_path === "/partners/"
      ? "/partners/settings/users/"
      : "/admins/settings/admins/";

  const renderLink = (to, label, icon, condition = true) =>
    condition && (
      <Link to={to} className={`dropdown-item ${isActive(to)}`}>
        <span className="icon">{icon}</span>
        <span>{label}</span>
      </Link>
    );

  const renderDropdown = (label, icon, routes, show = true) => {
    return (
      show && (
        <UncontrolledDropdown nav inNavbar className={isActive(routes[0].path)}>
          <DropdownToggle nav caret>
            <span className="icon">{icon}</span>
            <span>{label}</span>
          </DropdownToggle>
          <DropdownMenu right onClick={props.handleClose}>
            {routes.map((route, index) =>
              renderLink(route.path, route.label, route.icon)
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      )
    );
  };

  return (
    <Nav className="navbar-nav" navbar>
      <NavItem>
        <Link
          to="/"
          className={`nav-link ${isActive("/")}`}
          onClick={props.handleClose}
        >
          <span className="icon">
            <FaHome />
          </span>
          <span>Dashboard</span>
        </Link>
      </NavItem>

      {renderDropdown(
        "Products",
        <FaBoxes />,
        productsDropDownMenu(default_path, user)
      )}

      {renderDropdown(
        "Orders",
        <FaList />,
        ordersDropMenu(default_path, orderPath)
      )}

      {renderDropdown(
        "Promotions",
        <FaBoxes />,
        promotionsDropMenu(default_path, user)
      )}

      {default_path === "/admins/" && (
        <>
          {renderDropdown(
            "Categories",
            <FaProjectDiagram />,
            categoryDropDownMenu
          )}

          {renderDropdown("Partners", <FaUsers />, [
            {
              path: "/admins/partners/companies",
              label: "Businesses",
              icon: null,
            },
            { path: "/admins/partners/users", label: "Users", icon: null },
          ])}

          {renderDropdown(
            "Vouchers",
            <FaTags />,
            voucherDropMenu(default_path)
          )}

          {renderDropdown("Sales Personnels", <FaTags />, [
            {
              path: `${default_path}sales_personnels`,
              label: "All Personnels",
              icon: null,
            },
          ])}

          {renderDropdown(
            "Product Configurations",
            <FaCogs />,
            productConfigurationsDropMenu
          )}

          {renderDropdown(
            "Delivery Configurations",
            <FaTruck />,
            deliveryConfigurationsDropMenu
          )}

          {renderDropdown("Appearance", <FaImages />, appearancesDropMenu)}

          {renderDropdown("Points System", <FaCoins />, pointsSystemDropMenu)}
          {renderDropdown("Users", <FaUsers />, [
            { path: "/admins/users", label: "All Users", icon: null },

            {
              path: "/admins/users/has_pending_checkout",
              label: "Pending Checkout",
              icon: null,
            },
          ])}
          {renderDropdown("Reports", <FaChartLine />, reportsDropMenu)}
          {renderDropdown("Settings", <FaCog />, [
            { path: "/admins/settings/admins", label: "Admin", icon: null },
          ])}
        </>
      )}
    </Nav>
  );
};

const mapStateToProps = (state) => ({ authentication: state.authentication });
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Navigation)
);
Navigation.propTypes = {
  // Other prop types...
  handleClose: PropTypes.func.isRequired, // Add line
};
